<template>
  <div>
    <h2 class="text-2xl my-5 font-semibold uppercase" v-bind="$attrs">
      <slot />
    </h2>
  </div>
</template>

<script setup></script>
